export const UPDATE_DATA_BY_WIDGETS = 'newCars/UPDATE_DATA_BY_WIDGETS';
export const UPDATE_PHONE_BOOK_DATA = 'newCars/UPDATE_PHONE_BOOK_DATA';
export const UPDATE_WIDGETS = 'newCars/UPDATE_WIDGETS';
export const UPDATE_CARS_COMPARISON = 'newCars/UPDATE_CARS_COMPARISON';
export const UPDATE_COMPARISON_SEGMENT = 'newCars/UPDATE_COMPARISON_SEGMENT';
export const SHOW_CARS_COMPARISON_POPUP = 'newCars/SHOW_CARS_COMPARISON_POPUP';
export const UPDATE_LANDING_PAGE_DATA = 'newCars/UPDATE_LANDING_PAGE_DATA';
export const UPDATE_CITY_LIST = 'newCars/UPDATE_CITY_LIST';
export const UPDATE_MODEL_DETAILS = 'newCars/UPDATE_MODEL_DETAILS';
export const UPDATE_LISTING = 'newCars/UPDATE_LISTING';
export const UPDATE_SEARCH_DATA = 'newCars/UPDATE_SEARCH_DATA';
export const UPDATE_SEARCH_RESULTS = 'newCars/UPDATE_SEARCH_RESULTS';
export const UPDATE_TEST_DRIVE_DETAILS = 'newCars/UPDATE_TEST_DRIVE_DETAILS';
export const UPDATE_REVIEW_DETAILS = 'newCars/UPDATE_REVIEW_DETAILS';
export const RESET_WIDGET_DATA = 'newCars/RESET_WIDGET_DATA';
export const UPDATE_MODEL_REVIEW = 'newCars/UPDATE_MODEL_REVIEW';
export const UPDATE_WIDGET_SELECTED_STATE =
  'newCars/UPDATE_WIDGET_SELECTED_STATE';
export const UPDATE_CAR_JOURNEY_FILTERS = 'newCars/UPDATE_CAR_JOURNEY_FILTERS';
export const UPDATE_CAR_JOURNEY_ACTIVE_STEP =
  'newCars/UPDATE_CAR_JOURNEY_ACTIVE_STEP';
export const UPDATE_CAR_JOURNEY_PARTIAL_RESULT =
  'newCars/UPDATE_CAR_JOURNEY_PARTIAL_RESULT';
export const UPDATE_CAR_JOURNEY_FINAL_RESULT =
  'newCars/UPDATE_CAR_JOURNEY_FINAL_RESULT';
export const UPDATE_CAR_JOURNEY_BRAND_LIST =
  'newCars/UPDATE_CAR_JOURNEY_BRAND_LIST';
export const UPDATE_SWIPE_GESTURE = 'newCars/UPDATE_SWIPE_GESTURE';
export const UPDATE_BANNERS = "newCars/UPDATE_BANNERS";


export const UPDATE_DEALER_HOME_DATA =
  'dealerMarketing/UPDATE_DEALER_HOME_DATA';
export const UPDATE_DEALER_OFFER_DATA =
  'dealerMarketing/UPDATE_DEALER_OFFER_DATA';
export const UPDATE_DEALER_USER_ADDRESS =
  'dealerMarketing/UPDATE_DEALER_USER_ADDRESS';
export const UPDATE_DEALER_SELECTED_CITY =
  'dealerMarketing/UPDATE_DEALER_SELECTED_CITY';
export const UPDATE_DEALER_SELECTED_BRAND =
  'dealerMarketing/UPDATE_DEALER_SELECTED_BRAND';
export const UPDATE_DEALER_CITY_LIST =
  'dealerMarketing/UPDATE_DEALER_CITY_LIST';